export const PoemInsertYourNameHere = () => {
    return (
        <div id="007" className="">
            <p>ripped jeans, point and click, ersatz everything.</p>
            <p>life like sucking bone meal, quiet like a fever dream.</p>
            <p>a million tons of concrete laid on top of our bodies.</p>
            <p>
                you can always find a place in the rubble where your person will
                fit,
            </p>
            <p>polyester sky, polyurethane sleep,</p>
            <p>neon lights, always,</p>
            <p>everybody’s reciting digits to themselves, i wish</p>
            <p>there was something to ask to be delivered from,</p>
            <p>other than unmet expectations and my 9-to-5.</p>
            <p>can boredom kill the spirit?</p>
            <p>eye contact always with blinking line cursors,</p>
            <p>TV chyrons crawl on walls and floors around us,</p>
            <p>it’s easier to be acted upon than to -</p>
            <p>
                there’s nothing to return to if you don’t leave in the first
                place,
            </p>
            <p>
                the general wisdom should be “bang your head against the wall”.
            </p>
            <p>after we finish burning ourselves up</p>
            <p>who’s going to inherit the bones &amp; </p>
            <p>
                measure the way the flames disintegrated our flesh and hair
                follicules?
            </p>
            <p>don’t process anything that i say,</p>
            <p>there are moments when making sense of things </p>
            <p>can actually turn out to be the wrong call.</p>
            <p>a million tons of concrete laid on top of our bodies,</p>
            <p>and yet is it ever enough? there’s always</p>
            <p>a couple of fools slipping through to the atmosphere.</p>
            <p>and the method is always different,</p>
            <p>
                the plan always contained only in the skull of the perpetrator,
            </p>
            <p>ersatz everything,</p>
            <p>except for</p>
            <p>dull white days when nothing happens</p>
            <p>that scream at you “please make a mistake”,</p>
            <p>
                it’s easier to feign innocence, feign wisdom, feign
                understanding,
            </p>
            <p>but nothing speaks more than</p>
            <p>frayed edges on your T-shirt.</p>
        </div>
    );
};
